import { Auth0Client } from '@auth0/auth0-spa-js';

export interface AuthenticationResult {
  isAuthenticated: boolean;
  isAccessDenied?: boolean;
  shouldShowRedirectMessage?: boolean;
  auth0Client?: Auth0Client;
  accessToken?: string;
}

export interface AuthenticationHandler {
  initialize(): Promise<AuthenticationResult>;
  refresh?(): Promise<string | null>;
}

export enum AuthenticationMode {
  Web = 'web',
  LegacyApp = 'legacy-app',
  ReactNativeApp = 'react-native-app'
}

export interface AuthenticationConfig {
  domain: string;
  clientId: string;
  audience?: string;
  redirectUri?: string;
}
